import {
  IInboundPackageDetailData,
  IInboundPackageDetailDataRaw,
  IInventoryHistory,
  InventoryLocationType,
} from '../../../types';

// TODO: generate a type for the location name.
const generateLocationName = (location: InventoryLocationType): string => {
  switch (location) {
    case InventoryLocationType.INBOUND:
      return 'Inbound';
    case InventoryLocationType.OUTBOUND:
      return 'Outbound';
    case InventoryLocationType.BLACK_BOX:
      return 'Black Box';
    case InventoryLocationType.EVALUATION:
      return 'Evaluation';
    case InventoryLocationType.HAND_OVER:
      return 'Hand Over';
    default:
      return 'Unknown';
  }
};

/**
 * This function will format package summary details api response.
 */
export function formatPackageSummaryDetailsResponse(
  raw: IInboundPackageDetailDataRaw
): IInboundPackageDetailData {
  const { dealSummary, currentLocation, inventoryHistory } = raw || {};

  const {
    inventoryLocation,
    podName,
    podNumber,
    recordedAt,
    recordedBy,
    recordedUserId,
    trayNumber,
  } = currentLocation || {};

  const formattedInventoryHistory: IInventoryHistory[] = inventoryHistory.map(
    (history) => {
      const { key, value } = history;

      const {
        inboundType,
        podName: clPodName,
        podNumber: clPodNumber,
        recordedAt: clRecordedAt,
        recordedBy: clRecordedBy,
        recordedUserId: clRecordedUserId,
        transactionId,
        trayNumber: itemTrayNumber,
      } = value;

      return {
        label: generateLocationName(key),
        key,
        value: {
          inboundType,
          inventoryLocation: generateLocationName(inventoryLocation),
          podName: clPodName || 'none',
          podNumber: clPodNumber || 'none',
          recordedAt: clRecordedAt,
          recordedBy: clRecordedBy || 'none',
          recordedUserId: clRecordedUserId,
          transactionId,
          trayNumber: itemTrayNumber || 'none',
        },
      };
    }
  );

  return {
    dealSummary,
    currentLocation: {
      inventoryLocation: generateLocationName(inventoryLocation),
      trayNumber: trayNumber || 'none',
      podName: podName || 'none',
      podNumber: podNumber || 'none',
      recordedAt,
      recordedBy: recordedBy || 'none',
      recordedUserId,
      // TODO: Revise these missing types with @Renji
      location: '',
      locationBarCode: '',
      recordedOn: '',
      storage: '',
    },
    inventoryHistory: formattedInventoryHistory,
  };
}
